// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__3A_Ij","Search__element":"Search_Search__element__3-K_p","slide-in-left":"Search_slide-in-left__Ay6pD"};